module.exports = __webpack_public_path__ + "img/padCode.65d38460.png";